<template>
  <div class="footer pb30 bgf5f8">
    <div class="footer-content">
      <div class="top flex" style="justify-content:space-between;">
        <div class="t-l">
          <div style="display: flex;align-items:center;margin-top:39px;">
            <img :src="anyuLogo" alt="" style="width: 84px;height:61px;margin-right: 19px"/>
            <div style="color: #FFFFFF">
              <p style="font-size: 32px;letter-spacing: 8px;line-height: 1.3">安预在线</p>
              <p style="font-size: 18px;letter-spacing: 2px;text-align: left">AN YU ONLINE</p>
            </div>
          </div>
          <div class="flex" style="margin-top:41px;margin-bottom:36px;"> 
            <img src="/static/index/phone.png" alt="" style="width:33px;height:39px;">
            <div style="font-size: 40px;font-weight: 400;
            color:#fff;line-height: 34px;margin-left:19px;">400-005-3568</div>
          </div>
          <div style="font-size: 18px;color: #FFFFFF;line-height: 34px;text-align:left;margin-bottom:46px;">公司地址：河北石家庄高新区黄河大道89号9号楼2层2010号</div>
        </div>
        <div class="t-r flex" style="margin-top:40px;">
          <div style="margin-right:30px;">
             <img src="/static/index/Official.png" alt="" style="width:167px;height:167px;">
            <div class="QRCode-t">微信公众号</div>
          </div>
          <div>
             <img :src="appIcon" alt="" style="width:167px;height:167px;">
            <div class="QRCode-t">下载App</div>
          </div>
        </div>
      </div>
      <div class="down">
        <div>
            © 2016-2021 www.anyuonline.com 河北安预信息科技有限公司 版权所有
        </div>
        <div>
          <a href="https://beian.miit.gov.cn" target="_blank" style="color: #FFFFFF;margin-right:6px;text-decoration:none;">冀ICP备20005671号-1</a>
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=13010502001847"  target="_blank" style="color: #FFFFFF;text-decoration:none;">冀公网安备13019902000386号</a>
        </div>    
      </div>
    </div>
  </div>
</template>

<script>
import AnyuLogo from "@/assets/anyulogo.png"
import AppIcon from "@/assets/app.png"
export default {
  name: "HelloWorld",
  data() {
    return {
      anyuLogo: AnyuLogo,
      appIcon: AppIcon
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.footer {
  width: 100%;
  height: 358px;
  background-image: url('/static/index/footer.png');
  background-color: #f5f8fa;
}
.footer-content {
  width: 1216px;
  font-size: 16px;
  margin: 0 auto;
  background-size: 100% 100%;
  font-weight: 400;
  color: rgba(57, 67, 76, 1);
  text-align: center;
  display: flex;
  flex-direction: column;
}
.top{
  border-bottom: 1px solid #8A8A8A;
}
.t-l{
  width: 565px;
}
.down{
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 34px;
  text-align:left;
  display: flex;
  justify-content:space-between;
}
.QRCode-t{
  font-size: 24px;
  font-weight: 400;
  color:#fff;
  line-height: 34px;
  margin-top:20px;  
}
.flex{
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer/Footer.vue